/**
 * Here are all the Backend api calls for our modules
 */
import axios from 'axios'
import apiConfig from '../../config/ApiConfig.vue'
import LocalStorage from '../local-storage'

let AuthBaseApiClient = axios.create({
    baseURL : apiConfig.authBaseURI
});

let AuthApiClient = function () {
    if(LocalStorage.hasApiToken()){
        AuthBaseApiClient.defaults.headers.common['Authorization'] = LocalStorage.getApiTokenHeaderData();
    }
    return AuthBaseApiClient;
};

export default AuthApiClient


